import React, { useMemo, useState, useCallback, useLayoutEffect, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cart from './cart';
import CheckList from './checkList';
import Header from './header';
import { setErrorPopUp } from '@reducers/notification';
import { useTableModal } from './modals/useTableModal';
import { useTabModal } from './modals/useTabModal';
import LoadingScreen from '@components/common/Loader/newLoaderModal';
import { useTogoModal } from './modals/useTogoCreateModal';
import { useSubmitTabName, useHeaderSearch } from './header/headerHandler';
import getDeviceType from '@utility/deviceType';
import { urlSearchParams } from '@utility/utills';
import EventEmitter from '@utility/eventSubscribers';

const StoreChecksV2 = ({
  serverAppTheme,
  orderingPortraitOrientation,
  deviceGroup,
  deviceInfo,
  tableData,
  pageNo,
  authCountry,
  isTipOnlyEnabled,
  loading,
  setErrorPopUp,
  employeeHashTable,
  userInfo,
}) => {
  const [activeRow, setActiveRowState] = useState(null);
  const setActiveRow = useCallback(id => setActiveRowState(id), []);

  const activeCheck = useMemo(
    () => (activeRow != null ? tableData?.[activeRow] : null),
    [activeRow, tableData]
  );

  const { onOpenTable, jsx: tableModalsJSX } = useTableModal({
    serverAppTheme,
    orderingPortraitOrientation,
    deviceGroup,
    tableData,
    pageNo,
    deviceInfo,
    setErrorPopUp,
    employeeHashTable,
    userInfo,
  });

  const { onOpenTab, jsx: tabModalsJSX } = useTabModal({
    serverAppTheme,
    orderingPortraitOrientation,
    deviceGroup,
    tableData,
    pageNo,
    deviceInfo,
    setErrorPopUp,
    authCountry,
    isTipOnlyEnabled,
  });

  const { onOpenTogo, jsx: togoModalsJSX } = useTogoModal({
    serverAppTheme,
    orderingPortraitOrientation,
    isTogo: true,
    isLandScape: !orderingPortraitOrientation,
  });

  const submitTabName = useSubmitTabName();
  const onOpenSpeedOrder = useCallback(() => submitTabName('speedOrder'), [submitTabName]);

  const { isSearch, openSearch, closeSearch, searchUpdated, filteredTableData } = useHeaderSearch(tableData);
  const onOpenCounter = useCallback(() => submitTabName(), [submitTabName]);
  const isCounterLogin = useMemo(() => {
    const { isCounter, isDriveThru, isCallCenter } = getDeviceType();
    return (
      (isCounter || isDriveThru || isCallCenter) && !!urlSearchParams('login')
    );
  }, []);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.enableSideBar(false);
    }
  }, [])

  const counterLoginTriggered = useRef(false);
  useLayoutEffect(() => {
    if (counterLoginTriggered.current) return;
    if (isCounterLogin) {
      counterLoginTriggered.current = true;
      submitTabName();
    }
  }, [isCounterLogin, submitTabName]);

  if (isCounterLogin) {
    return <LoadingScreen />;
  }

  return (
    <div
      className="h-100 d-flex flex-column"
    >
      {loading && <LoadingScreen />}
      <div className="h-10">
        <Header
          onOpenTable={onOpenTable}
          onOpenTab={onOpenTab}
          onOpenTogo={onOpenTogo}
          onOpenSpeedOrder={onOpenSpeedOrder}
          onOpenCounter={onOpenCounter}
          deviceId={deviceInfo?.deviceId}
          isSearch={isSearch}
          openSearch={openSearch}
          closeSearch={closeSearch}
          searchUpdated={searchUpdated}
        />
      </div>
      <div className="d-flex h-90 mx-2 pb-2">
        <CheckList
          tableData={filteredTableData}
          pageNo={pageNo}
          serverAppTheme={serverAppTheme}
          activeRow={activeRow}
          setActiveRow={setActiveRow}
        />
        <Cart seat={activeCheck} serverAppTheme={serverAppTheme} />
      </div>
      {tableModalsJSX}
      {tabModalsJSX}
      {togoModalsJSX}
    </div>
  );
};

const mapStateToProps = ({ theme, oauth, storeChecks, orders, checks, payment }) => ({
  serverAppTheme: theme.serverAppTheme ?? {},
  orderingPortraitOrientation: false,
  deviceGroup: oauth.deviceInformation?.deviceGroup,
  deviceInfo: oauth.deviceInformation,
  tableData: storeChecks.checkListHashTable ?? {},
  pageNo: orders.pageNo ?? 0,
  authCountry: oauth.authInfo?.country ?? 1,
  isTipOnlyEnabled: storeChecks.isTipOnlyEnabled ?? false,
  loading:
    storeChecks.loading ||
    checks.loading ||
    orders.loading ||
    payment.loading,
  employeeHashTable: oauth.employeeHashTable,
  userInfo: oauth.loggedInUserData,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setErrorPopUp }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StoreChecksV2);
